import {
	COMMON_KEYWORD_ENTITY_METADATA,
	ICommonKeywordEntityMetadata
}                     from '@app/modules/keyword/config/common-keyword.config';
import { APP_CONFIG } from '@appConfig/_app-config_master';
import {
	IFormCreateData,
	IFormData,
	IFormUpdateData
}                     from '@core/interfaces/form.interface';


export interface IArchivingKeywordMetadata extends ICommonKeywordEntityMetadata {

	entityId: string;

	storeId: string;

	form: {
		baseData: {
			id: IFormData;
			color: IFormData;
			name: IFormData;
		};
		createData: IFormCreateData[];
		updateData: IFormUpdateData[];
		preserveData: IFormUpdateData[];
	};
}


export const ARCHIVING_KEYWORD_METADATA: IArchivingKeywordMetadata = {
	...COMMON_KEYWORD_ENTITY_METADATA,
	entityId: APP_CONFIG.archivingKeyword.entityId,
	storeId: APP_CONFIG.archivingKeyword.store.id,
	form: {
		baseData: {
			id: {
				hide: true,
				specialTreatments: null,
				order: null,
				i18nPath: ''
			},
			color: {
				hide: true,
				hideLabel: true,
				i18nPath: '',
				order: 0,
				showInfo: false,
				specialTreatments: null
			},
			name: {
				hide: true,
				hideLabel: true,
				i18nPath: 'keyword.form.name',
				order: 1,
				showInfo: false,
				specialTreatments: null
			}
		},
		createData: [],
		updateData: [],
		preserveData: [
			{ key: 'id', fallbackValue: null },
			{ key: 'created', fallbackValue: null },
			{ key: 'lastModified', fallbackValue: null },
			{ key: 'etag', fallbackValue: null }
		]
	}
};
